/* eslint-disable sonarjs/cognitive-complexity */
'use client';

import { EmptySubscriptionProgress } from '@ahamove/icons/empty';
import {
  Button,
  Group,
  SimpleGrid,
  Skeleton,
  Stack,
  Text,
  Title,
  rem,
} from '@mantine/core';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';
import { useGetProgressesSubscriptionList } from '../../api';
import ProgressesItem from './progresses-item';
import { ResultBlock } from '@/components/result-block';
import {
  useSubscriptionsStore,
  SubscriptionTab,
} from '@/features/booking/store';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

export default function ProgressesSubscriptionList() {
  const activeTab = useSubscriptionsStore.use.activeTab();
  const setActiveTab = useSubscriptionsStore.use.setActiveTab();

  const { data, isLoading } = useGetProgressesSubscriptionList({
    enabled: activeTab === SubscriptionTab.my_subscriptions,
    staleTime: 10 * 1000,
  });

  const tSubscription = useTranslations('subscription');
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <Group
        px={isMobile ? rem(16) : rem(24)}
        gap={isMobile ? rem(8) : rem(16)}
      >
        {new Array(isMobile ? 3 : 6).fill(
          <Skeleton
            display={'block'}
            w={`calc(${isMobile ? '100%' : `50% - ${rem(8)}`})`}
            h={rem(112)}
            radius={rem(12)}
          />
        )}
      </Group>
    );
  }

  if (!data?.data?.length) {
    return (
      <ResultBlock
        className="justify-start p-[24px] md:p-0"
        icon={EmptySubscriptionProgress}
        iconSize={160}
      >
        <Stack gap={rem(24)} align="center" mt={rem(-16)}>
          <Text
            size={isMobile ? 'sm' : 'md'}
            fw={500}
            c="#4C5158"
            maw={rem(311)}
          >
            {tSubscription('empty_list_progress')}
          </Text>
          <Button
            variant="light"
            fw={700}
            mih={rem(48)}
            maw={rem(200)}
            onClick={() => {
              setActiveTab(SubscriptionTab.subscription);
            }}
          >
            Khám phá gói hội viên
          </Button>
        </Stack>
      </ResultBlock>
    );
  }

  return (
    <>
      <Stack
        pb={rem(24)}
        px={isMobile ? rem(16) : rem(24)}
        gap={rem(12)}
        style={{
          overflow: 'hidden',
        }}
      >
        {isMobile ? (
          <Title order={4} c="neutral.7">
            Gói đã mua
          </Title>
        ) : null}

        <SimpleGrid
          cols={isMobile ? 1 : 2}
          spacing={isMobile ? rem(8) : rem(16)}
          pt={rem(8)}
        >
          {data?.data.map((item, index) => (
            <Fragment key={item?._id || index}>
              <ProgressesItem data={item} />
            </Fragment>
          ))}
        </SimpleGrid>
      </Stack>
      {/* <Box
        bg="linear-gradient(180deg, #FFEBDC 0%, #FFF 100%)"
        mih={rem(192)}
        p={isMobile ? 'md' : rem(24)}
        c="neutral.7"
      >
        <Title order={4}>Gợi ý cho bạn</Title>
      </Box> */}
    </>
  );
}
